import { render, staticRenderFns } from "./subsidiary.vue?vue&type=template&id=1d1dffb9&scoped=true&"
import script from "./subsidiary.vue?vue&type=script&lang=js&"
export * from "./subsidiary.vue?vue&type=script&lang=js&"
import style0 from "./subsidiary.vue?vue&type=style&index=0&id=1d1dffb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1dffb9",
  null
  
)

export default component.exports